import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import RouteName from './route-name';
import NotFound from '@/views/not-found.vue';
import { countryPath, isCountryNavigationAllow } from './helpers';
import countries from '@/config/country';
import authentication from '@/core/authentication/authentication';
import ApplicationProcess from '@/views/application-process.vue';
import {ApplicationProcessLayoutName, UserAdminLayoutName} from '@/layouts/global-component';
import ApplicationPayment from '@/views/application-payment.vue';
import ApplicationSuccess from '@/views/application-success.vue';
import CompleteCart from '@/views/complete-cart.vue';


const routes: Array<RouteRecordRaw> = [
    {
        path: countryPath('/application', countries),
        name: RouteName.APPLICATION_PROCESS,
        component: ApplicationProcess,
        meta: { isCountryRoute: true, layout: ApplicationProcessLayoutName }
    },
    {
        path: countryPath('/trade-mark', countries),
        redirect: to => {
            return to.path.replace(/trade-mark$/, 'application')
        },
    },
    {
        path: countryPath('/goods', countries),
        redirect: to => {
            return to.path.replace(/goods$/, 'application')
        },
    },
    {
        path: countryPath('/contact', countries),
        redirect: to => {
            return to.path.replace(/contact$/, 'application')
        },
    },
    {
        path: countryPath('/payment', countries),
        name: RouteName.PAYMENT,
        component: ApplicationPayment,
        meta: {  isCountryRoute: true, layout: ApplicationProcessLayoutName }
    },
    {
        path: countryPath('/success', countries),
        name: RouteName.SUCCESS,
        component: ApplicationSuccess,
        meta: {  isCountryRoute: true, layout: ApplicationProcessLayoutName },
        props: (route) => ({
            stripe_id: route.query.stripe_id as string | undefined,
            paypal_id: route.query.paypal_id as string | undefined
        })
    },
    {
        path: countryPath('/complete-cart/:cartRef', countries),
        name: RouteName.COMPLETE_CART,
        component: CompleteCart,
        meta: { isCountryRoute: true, layout: ApplicationProcessLayoutName }
    },
    {
        path: '/:pathMatch(.*)*',
        name: RouteName.NOT_FOUND,
        component: NotFound,
        meta: { layout: UserAdminLayoutName }
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        // scroll to top
        const appElement = document.getElementById('app');
        if (appElement !== null) {
            appElement.scrollIntoView();
        }
        window.parent.postMessage({ command: 'toTop', message: 'toTop' }, '*');
    }
});

router.beforeEach(async (to, from, next) => {
    const isAllowed = isCountryNavigationAllow(to, countries);

    if (!isAllowed) {
        return next({ name: RouteName.NOT_FOUND });
    }

    if(to.matched.some(record => record.meta.requiresAuth)) {
        const isAuth = await authentication.isAuth();
        if(isAuth) {
            return next();
        } else {
            // store.dispatch('authentication/setLoading', false)
            return next({ name: RouteName.LOGIN });
        }
    }
    return next();
});


export default router;
